var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgLegislation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.468,
    height: 18.477,
    viewBox: "0 0 23.468 18.477"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-legislation_svg__cls-1,.kpmg-legislation_svg__cls-5,.kpmg-legislation_svg__cls-7{fill:none}.kpmg-legislation_svg__cls-1,.kpmg-legislation_svg__cls-2,.kpmg-legislation_svg__cls-5{stroke:#009ceb;stroke-width:1.6px}.kpmg-legislation_svg__cls-1,.kpmg-legislation_svg__cls-2,.kpmg-legislation_svg__cls-4,.kpmg-legislation_svg__cls-5{stroke-linecap:round}.kpmg-legislation_svg__cls-2,.kpmg-legislation_svg__cls-4{fill:#fff}.kpmg-legislation_svg__cls-2,.kpmg-legislation_svg__cls-4,.kpmg-legislation_svg__cls-5{stroke-linejoin:round}.kpmg-legislation_svg__cls-6,.kpmg-legislation_svg__cls-8{stroke:none}.kpmg-legislation_svg__cls-8{fill:#009ceb}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__ICN_Legislatie",
    transform: "translate(-400.782 -259.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-legislation_svg__Line_644",
    "data-name": "Line 644",
    className: "kpmg-legislation_svg__cls-1",
    transform: "translate(412.5 263.5)",
    d: "M0 0v13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Rectangle_562",
    "data-name": "Rectangle 562",
    className: "kpmg-legislation_svg__cls-2",
    transform: "translate(407 276)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-legislation_svg__cls-6",
    width: 11,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-legislation_svg__cls-7",
    x: 0.8,
    y: 0.8,
    width: 9.4,
    height: 0.4,
    rx: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Rectangle_563",
    "data-name": "Rectangle 563",
    className: "kpmg-legislation_svg__cls-2",
    transform: "translate(410 275)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-legislation_svg__cls-6",
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "kpmg-legislation_svg__cls-7",
    x: 0.8,
    y: 0.8,
    width: 3.4,
    height: 0.4,
    rx: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-legislation_svg__Line_645",
    "data-name": "Line 645",
    className: "kpmg-legislation_svg__cls-1",
    transform: "translate(403.5 260.5)",
    d: "M0 0l19 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Ellipse_228",
    "data-name": "Ellipse 228",
    transform: "translate(410 260)",
    fill: "#fff",
    stroke: "#009ceb",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-legislation_svg__cls-6",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "kpmg-legislation_svg__cls-7",
    cx: 2.5,
    cy: 2.5,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Group_2484",
    "data-name": "Group 2484",
    transform: "translate(-1311 -1816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Path_1026",
    "data-name": "Path 1026",
    className: "kpmg-legislation_svg__cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-legislation_svg__cls-6",
    d: "M3.5 5.703C2.299 5.703 1.28 4.901.94 3.8h5.141A2.708 2.708 0 013.5 5.703z",
    transform: "translate(1728 2085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-legislation_svg__cls-8",
    d: "M2.483 4.6a1.85 1.85 0 001.017.303c.379 0 .732-.111 1.03-.303H2.482M.021 3h6.982A3.503 3.503 0 013.5 6.503C1.565 6.503.02 4.935.02 3z",
    transform: "translate(1728 2085)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-legislation_svg__Path_1027",
    "data-name": "Path 1027",
    className: "kpmg-legislation_svg__cls-5",
    d: "M-5094.178-10452.97l2.632-6.58 2.75 6.58",
    transform: "translate(6823 12541)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Group_2485",
    "data-name": "Group 2485",
    transform: "translate(-1327 -1820)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-legislation_svg__Path_1026-2",
    "data-name": "Path 1026",
    className: "kpmg-legislation_svg__cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-legislation_svg__cls-6",
    d: "M3.5 5.703C2.299 5.703 1.28 4.901.94 3.8h5.141A2.708 2.708 0 013.5 5.703z",
    transform: "translate(1728 2085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-legislation_svg__cls-8",
    d: "M2.483 4.6a1.85 1.85 0 001.017.303c.379 0 .732-.111 1.03-.303H2.482M.021 3h6.982A3.503 3.503 0 013.5 6.503C1.565 6.503.02 4.935.02 3z",
    transform: "translate(1728 2085)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-legislation_svg__Path_1027-2",
    "data-name": "Path 1027",
    className: "kpmg-legislation_svg__cls-5",
    d: "M-5094.178-10452.97l2.632-6.58 2.75 6.58",
    transform: "translate(6823 12541)"
  })))));
}

export default SvgKpmgLegislation;